import { ModalHeaderContainer, ModalHeaderTitle } from '../styled-components'
import ButtonComponent from '../../button'
import { Cancel } from '../../icons/essentials'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../../button/constants'
import PropTypes from 'prop-types'
import colorsOptions from '../../../fundamentals/colors-styles/constants.js'

const ModalHeader = ({ title, onClose, showCloseButton }) => {
  return (
    <ModalHeaderContainer>
      <ModalHeaderTitle>{title}</ModalHeaderTitle>
      {showCloseButton && onClose && (
        <ButtonComponent
          onClick={onClose}
          variant={buttonVariantOptions.GHOST}
          buttonType={buttonTypeOptions['ICON-ONLY']}
          size={buttonSizeOptions.SMALL}
          style={{
            stroke: colorsOptions.greys['grey-70']
          }}
        >
          <Cancel variant={buttonVariantOptions.GHOST} />
        </ButtonComponent>
      )}
    </ModalHeaderContainer>
  )
}

ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool
}

export default ModalHeader
